var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model, Watch } from 'vue-property-decorator';
import { Teacher } from '@/models/Teacher';
import { dayMap, defaultCalendarSettings } from '@/support/CalendarDefaults';
import { Holiday } from '@/models/Holiday';
import { ContractHour } from '@/models/ContractHour';
import ErrorHandler from '@/support/ErrorHandler';
import AddEventDialog from '@/components/mi-calendar/AddEventDialog';
import { Event as EventModel } from '@/models/Event';
import { parseToEventModel, parseToCalendarEvents } from '@/support/CalendarEventFunctions';
import LoaderCard from '@/components/loader-card/LoaderCard';
let Calendar = class Calendar extends Vue {
    constructor() {
        super(...arguments);
        this.backgroundEvents = [];
        this.events = [];
        this.contracthours = [];
        this.isCreatingEvent = false;
        this.eventData = null;
        this.selectedEventId = null;
        this.isLoading = false;
        this.hasWeekends = false;
    }
    get weekStart() {
        const setting = this.$store.state.settings.find((setting) => {
            return setting.key === 'first_day_of_week';
        });
        if (setting) {
            this.hasWeekends = this.hasWeekendsInSchoolTimes() ? this.hasWeekendsInSchoolTimes() : ['sunday', 'saturday'].includes(setting.value);
            return dayMap[setting.value];
        }
        return 1;
    }
    get calendarOptions() {
        return {
            ...defaultCalendarSettings,
            ...{
                editable: true,
                buttonText: {
                    today: this.$t('rosterManagement.today').toString(),
                },
                header: {
                    left: 'title',
                    right: 'prev, today, next',
                },
                firstDay: this.weekStart,
                weekends: this.hasWeekends,
                eventOverlap: false,
                businessHours: this.contractHours,
                eventConstraint: 'businessHours',
                selectConstraint: 'businessHours',
                select: (selectionInfo) => {
                    this.createCalendarEvent(selectionInfo);
                },
                eventRender: (eventInfo) => { },
                eventClick: (selectionInfo) => {
                    this.selectedEventId = selectionInfo.event.id;
                    this.createCalendarEvent(selectionInfo.event);
                },
                eventDrop: (eventDropInfo) => {
                    this.updateEvent(parseToEventModel(eventDropInfo.event), eventDropInfo);
                },
                eventResize: (eventResizeInfo) => {
                    this.updateEvent(parseToEventModel(eventResizeInfo.event), eventResizeInfo);
                },
            },
        };
    }
    get contractHours() {
        return this.contracthours.map((contracthour) => {
            if (!contracthour.id) {
                return {};
            }
            return {
                daysOfWeek: [dayMap[contracthour.id]],
                startTime: contracthour.starts_at ? contracthour.starts_at : '',
                endTime: contracthour.ends_at ? contracthour.ends_at : '',
            };
        });
    }
    mounted() {
        this.fetchContractHours();
        this.fetchEvents();
        this.isLoading = true;
        // this.fetchHolidays();
    }
    hasWeekendsInSchoolTimes() {
        const saturday = this.$store.state.openingHours.find((hour) => {
            return hour.id === 'saturday';
        });
        const sunday = this.$store.state.openingHours.find((hour) => {
            return hour.id === 'sunday';
        });
        return sunday.starts_at !== '00:00:00' && sunday.ends_at !== '00:00:00' || saturday.starts_at !== '00:00:00' && saturday.ends_at !== '00:00:00';
    }
    createCalendarEvent(selectionInfo) {
        this.eventData = parseToEventModel(selectionInfo);
        this.isCreatingEvent = true;
    }
    updateCalendar(event) {
        const eventsClone = [...this.events]; // clone
        const eventIndex = this.getEventIndex(eventsClone, event.id || '');
        if (eventIndex >= 0) {
            eventsClone[eventIndex] = event.calendarEvent;
        }
        this.$set(this, 'events', eventsClone);
    }
    removeEvent() {
        const eventIndex = this.getEventIndex(this.events, this.selectedEventId || '');
        if (eventIndex >= 0) {
            this.events.splice(eventIndex, 1);
        }
    }
    refreshCalendar(event) {
        this.events.push(event.calendarEvent);
    }
    updateEvent(event, calendarEvent) {
        event
            .update()
            .then((event) => {
        })
            .catch((error) => {
            ErrorHandler.network(error);
            calendarEvent.revert();
        });
    }
    // fetchEvent
    fetchEvents() {
        new EventModel()
            .filter({
            users: [this.teacher.id],
            type: 'other',
        })
            .all()
            .then((events) => {
            this.events = parseToCalendarEvents(events);
            this.isLoading = false;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    fetchContractHours() {
        new ContractHour()
            .filter('user', this.teacher.id)
            .sort('weekdays')
            .all()
            .then((hours) => {
            this.contracthours = hours;
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    fetchHolidays() {
        new Holiday()
            .limit(1000)
            .all()
            .then((holidays) => {
            const events = [];
            holidays.forEach((holiday) => {
                events.push(holiday.backgroundEvent);
            });
            this.backgroundEvents = events;
        });
    }
    changedCurrentWeekStart() {
        this.isLoading = true;
    }
    getEventIndex(events, id) {
        return this.events.findIndex((element) => {
            return element.id === id;
        });
    }
};
__decorate([
    Model('teacher', { default: () => new Teacher() }),
    __metadata("design:type", typeof (_a = typeof Teacher !== "undefined" && Teacher) === "function" ? _a : Object)
], Calendar.prototype, "teacher", void 0);
__decorate([
    Watch('weekStart'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Calendar.prototype, "changedCurrentWeekStart", null);
Calendar = __decorate([
    Component({
        components: {
            AddEventDialog,
            LoaderCard,
        },
    })
], Calendar);
export default Calendar;
